import { UPDATE_DEALER_CREDENTIALS, UPDATE_DEALER_CREDENTIALS_SUCCESSFUL, UPDATE_DEALER_CREDENTIALS_FAILED,RESET_ALERT} from "./actionTypes"

const initialState = {
    updateError: null,
    updateloading: false,
    updatemessage: null
}

const addDealerCredentials = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_DEALER_CREDENTIALS:
            state = {
                ...state,
                updateloading: true,
                updateError: null,
                updatemessage: null,
            }
            break;

        case UPDATE_DEALER_CREDENTIALS_SUCCESSFUL:
            state = {
                ...state,
                updateloading: false,
                updatemessage: action.payload.message,
                updateError: null,
            }
            break;

        case UPDATE_DEALER_CREDENTIALS_FAILED:
            state = {
                ...state,
                updateloading: false,
                updateError: action.payload,
                updatemessage: null
            }
            break;
        case RESET_ALERT:
            state = {
                ...state,
                updateloading: false,
                updateError: null,
                updatemessage: null
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default addDealerCredentials;